import { FormikErrors } from 'formik'
import { Field as BaseField } from 'components/Wizards/Field/Field'
import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2 } from 'blaze-ui/icons'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'
import InputStyles from 'almanac-ui/TextInputField/Input.module.scss'
import Styles from './TemplateAndCaption.module.scss'
import cx from 'classnames'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useRef } from 'react'

interface Props {
  caption: string
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => Promise<void | FormikErrors<{}>>
  onUpdate: (val: boolean) => void
  isLoading: boolean
  label?: string
  showWriteMyOwn?: boolean
}

export const CaptionField = ({
  caption,
  setFieldValue,
  onUpdate,
  isLoading,
  label = 'Post caption',
  showWriteMyOwn = false,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <BaseField
      label={label}
      isRequired
      fieldGap={5}
      rightContent={
        <Button
          variant="ghost"
          size="sm"
          frontIcon={ArrowRefresh2}
          onPress={() => {
            setFieldValue('caption', '')
            onUpdate(false)
          }}
        >
          Regenerate
        </Button>
      }
    >
      {isLoading && <TextFieldLoadingState lines={4} />}
      {!isLoading && (
        <div className={Styles.captionInputContainer}>
          <Input
            ref={inputRef}
            aria-label="post caption"
            name="caption"
            placeholder="Add a caption to your post"
            withBorder
            value={caption}
            isTextarea
            onChange={(event) => setFieldValue('caption', event.target.value)}
            className={cx(InputStyles.input, InputStyles.md, InputStyles.textarea, Styles.caption)}
          />
          {showWriteMyOwn && (
            <Button
              variant="secondary"
              size="sm"
              onPress={() => {
                setFieldValue('caption', '')
                inputRef.current?.focus()
              }}
            >
              I'll write my own
            </Button>
          )}
        </div>
      )}
    </BaseField>
  )
}
